export enum NotificationEnum {
	None,
	Add,
	Update,
	Delete,
	Error
}
